import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiNewsService } from '../../../../services/news/api/api-news.service';
import { AlertsService } from '../../../../services/alerts.service';
import { NewsPredefined } from '../../../../models/news/news-predefined.model';

@Component({
  selector: 'app-news-predefined-edit-modal',
  templateUrl: './news-predefined-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class NewsPredefinedEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  newsPredefinedId: number = 0;
  name: string = '';

  private callbackSaved?: () => void;

  constructor(private apiNewsService: ApiNewsService, private alertsService: AlertsService) {}

  show(item: NewsPredefined, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.newsPredefinedId = item.newsPredefinedId;
    this.name = item.name;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiNewsService.editNewsPredefined(this.newsPredefinedId, this.name).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Predefined news updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating predefined news : ' + error);
      }
    );
  }
}
